import React from "react";
import contextProvider from "../../contextProvider";
import { ButtonGroup, Input, Row, Col } from "reactstrap";
// import { withToastManager } from "react-toast-notifications";
import { withRouter } from "react-router-dom";
import _ReactOBaseComponent from "../../_L0_components/_ReactOBaseComponent";

import ReactOButton from "../../_L1_components/Elements/ReactOButton";
import ReactOActionBar from "../../_L1_components/Elements/ReactOActionBar";
import Section from "../../_L1_components/Layout/Section";

import MapView from "../Subroutes/Dashboard/MapView";
import ProbesView from "../Subroutes/Dashboard/ProbesView";
import EssidView from "../Subroutes/Dashboard/EssidView";
import DiagView from "../Subroutes/Dashboard/DiagView";
import SmartView from "../Subroutes/Dashboard/SmartView";

const allowViews = ["card", "essid", "map", "diag"];

class Dashboard extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: true,
      locations_loading: true,
      data: null,
      locations_data: null,
      viewMode: null,
      searchKey: "",
    };
    super(props, initState);

    this.apiStore = null;
    this.actionsShelf = null;
    this.search = new URLSearchParams(window.location.search);
    // this._viewMode = "card";
  }

  switchViewMode(mode, prb_id) {
    if (mode == "map" && this.state.viewMode != mode) {
      this.state.viewMode = "map";
      this.getAppContext()
        .getLocalStorageService()
        .set("dashboard_view_mode", "map");
      this.props.history.push("/dashboard?tab=map");
      this.setState({
        probeMapFocus: prb_id,
        viewMode: "map",
        loading: true,
      });
    } else if (mode == "card" && this.state.viewMode != mode) {
      this.state.viewMode = "card";
      this.getAppContext()
        .getLocalStorageService()
        .set("dashboard_view_mode", "card");
      this.props.history.push("/dashboard?tab=card");
      this.setState({ viewMode: "card", loading: true });
    } else if (mode == "essid" && this.state.viewMode != mode) {
      this.state.viewMode = "essid";
      this.getAppContext()
        .getLocalStorageService()
        .set("dashboard_view_mode", "essid");
      this.props.history.push("/dashboard?tab=essid");
      this.setState({ viewMode: "essid", loading: true });
    } else if (mode == "diag" && this.state.viewMode != mode) {
      this.state.viewMode = "diag";
      this.getAppContext()
        .getLocalStorageService()
        .set("dashboard_view_mode", "diag");
      this.props.history.push("/dashboard?tab=diag");
      this.setState({ viewMode: "diag", loading: true });
    } else if (mode == "smart" && this.state.viewMode != mode) {
      this.state.viewMode = "smart";
      this.getAppContext()
        .getLocalStorageService()
        .set("dashboard_view_mode", "smart");
      this.props.history.push("/dashboard?tab=smart");
      this.setState({ viewMode: "smart", searchKey: "", loading: true });
    }
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    this.getAppContext().getLocalStorageService().remove("prevSelectedTags");
    this.getAppContext().getLocalStorageService().remove("goBackTags");
    this.getAppContext().getLocalStorageService().remove("goBackExplorer");
    const search = new URLSearchParams(this.getAppContext().getUrlParams);
    if (!this.getAppContext().isCloud()) {
      this.getAppContext().redirectTo("/edge/active", true);
    }

    if (
      window.location.search == "?view" &&
      this.getAppContext().authHandler.getAccountData().probe_number &&
      this.getAppContext().authHandler.getAccountData().probe_number == 1 &&
      this.getAppContext().authHandler.getAccountData().probeid
    ) {
      let probeid = this.getAppContext().authHandler.getAccountData().probeid;
      this.getAppContext().redirectTo("/" + probeid + "/active");
    }
    let view = null;
    if (search.get("tab") == "diag") {
      view = "diag";
      this.getAppContext()
        .getLocalStorageService()
        .set("dashboard_view_mode", view);
      this.props.history.push(`/dashboard${this.getAppContext().getUrlParams}`);
    } else if (
      this.search.get("tab") &&
      allowViews.includes(this.search.get("tab"))
    ) {
      view = this.search.get("tab");
      this.getAppContext()
        .getLocalStorageService()
        .set("dashboard_view_mode", view);
    } else if (
      this.getAppContext().getLocalStorageService().isSet("dashboard_view_mode")
    ) {
      view = this.getAppContext()
        .getLocalStorageService()
        .get("dashboard_view_mode");
      this.props.history.push(`/dashboard?tab=${view}`);
    } else {
      view = "card";
      this.getAppContext()
        .getLocalStorageService()
        .set("dashboard_view_mode", "card");
      this.props.history.push(`/dashboard?tab=${view}`);
    }
    this.setState({ viewMode: view }, () => {
      this.apiStore = this.getAppContext().getApiStoreService();
      this.actionsShelf = this.getAppContext().getActionsShelfService();
      this.getAppContext()
        .getLocalStorageService()
        .remove("measure_graph_view");
      this.getAppContext()
        .getLocalStorageService()
        .remove("measure_graph_view");
      this.getAppContext().getLocalStorageService().isSet("nav_position") &&
        this.getAppContext().getLocalStorageService().remove("nav_position");
    });
  }

  onComponentWillUnmount(p) {
    this.getAppContext().setUrlParams("");
  }

  disableLoading() {
    this.setState({ loading: false });
  }

  onRender() {
    return (
      <Section className="p-3" designType="narrow">
        {this.state.viewMode && (
          <>
            <ReactOActionBar
              className="mt-3 mb-3 d-flex justify-content-between align-items-center" // p-3 border-bottom border-3 border-gray300
              padding="0"
            >
              <ButtonGroup>
                <ReactOButton
                  size={this.getAppContext().media.isMobile ? "sm" : "md"}
                  icon="dashboard"
                  color={this.state.viewMode == "card" ? "primary" : "light"}
                  onClick={() => {
                    // this.search.set("p", "d");
                    this.switchViewMode("card");
                  }}
                >
                  <strong>Probe list</strong>
                </ReactOButton>
                {this.getAppContext().authHandler.getAccountData().show_map ==
                "yes" ? (
                  <ReactOButton
                    size={this.getAppContext().media.isMobile ? "sm" : "md"}
                    icon="map"
                    color={this.state.viewMode == "map" ? "primary" : "light"}
                    onClick={() => {
                      this.switchViewMode("map");
                    }}
                  >
                    <strong>Map</strong>
                  </ReactOButton>
                ) : null}

                {this.getAppContext().authHandler.getAccountData()
                  .smart_notifications &&
                this.getAppContext().authHandler.getAccountData()
                  .smart_notifications == "yes" ? (
                  <ReactOButton
                    size={this.getAppContext().media.isMobile ? "sm" : "md"}
                    icon="graph-line"
                    color={this.state.viewMode == "smart" ? "primary" : "light"}
                    onClick={() => {
                      this.switchViewMode("smart");
                    }}
                  >
                    <strong>Smart diagnostics</strong>
                  </ReactOButton>
                ) : (
                  <ReactOButton
                    size={this.getAppContext().media.isMobile ? "sm" : "md"}
                    icon="graph-line"
                    color={this.state.viewMode == "diag" ? "primary" : "light"}
                    onClick={() => {
                      this.switchViewMode("diag");
                    }}
                  >
                    <strong>Diagnostics</strong>
                  </ReactOButton>
                )}
              </ButtonGroup>
              {this.state.viewMode == "smart" ? (
                <div>
                  <Row>
                    <Col xl={12} className="ml-auto">
                      <Input
                        type="text"
                        className="form-input-text"
                        placeholder="Tags search"
                        bsSize="md"
                        disabled={this.state.loading}
                        onChange={(e) => {
                          this.setState({ searchKey: e.target.value });
                        }}
                      />
                    </Col>
                  </Row>
                </div>
              ) : null}
            </ReactOActionBar>

            {this.state.viewMode == "map" ? (
              <MapView probeMapFocus={this.state.probeMapFocus} />
            ) : this.state.viewMode == "essid" ? (
              <EssidView />
            ) : this.state.viewMode == "card" || !this.state.viewMode ? (
              <ProbesView
                onProbePositionClick={(prb_id) => {
                  this.switchViewMode("map", prb_id);
                }}
              />
            ) : this.state.viewMode == "diag" ? (
              <DiagView />
            ) : this.state.viewMode == "smart" ? (
              <SmartView
                searchKey={this.state.searchKey}
                disableLoading={() => this.disableLoading()}
              />
            ) : null}
          </>
        )}
      </Section>
    );
  }
}

export default contextProvider(
  withRouter(Dashboard),
  //	withDefinedContext(Account, 'Account', context_exposed_methods),
  {
    define: null,
  },
);
